import {call, put, take} from 'redux-saga/effects'

export function* sendToServer({EVENT, request, waiting, success, failure}) {
    while (true) {
        const event = yield take(EVENT);
        try {
            const {url, data} = yield* request(event);
            try {
                yield put(waiting());
                const response = yield call(fetch, url, {
                    method:  'POST',
                    headers: {'Content-Type': 'application/json'},
                    body:    JSON.stringify(data)
                });
                if (response.ok) {
                    yield put(success());
                } else {
                    yield put(failure());
                }
            } catch (error) {
                yield put(failure());
            }
        } catch (error) {
            // unable to retrieve url/data, loop over
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/sagas.js